import { render, staticRenderFns } from "./EOIBenefits.vue?vue&type=template&id=63a91827&scoped=true"
import script from "./EOIBenefits.vue?vue&type=script&lang=js"
export * from "./EOIBenefits.vue?vue&type=script&lang=js"
import style0 from "./EOIBenefits.vue?vue&type=style&index=0&id=63a91827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a91827",
  null
  
)

export default component.exports